import _ from 'lodash';
import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';

import { sampleDataGetAiOcr } from './sampleDataGetAiOcr.js';

// const isMock = true;
const isMock = false;

export function useBffAiOcrInitial(options = {}) {
  const { initialQueries = {}, immediate = true } = options;
  // console.log('useBff: ', initialQueries.documentManageId);

  const data = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const fetchData = async (queries = initialQueries) => {
    loading.value = true;
    error.value = null;

    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/AiOcr/getAiOcr',
        query: {
          processId: initialQueries.processId || 'ICREQ01',
          documentManageId: initialQueries.documentManageId,
          documentTrx: initialQueries.documentTrx,
        },
        path: {
          companyId: initialQueries.documentTrx,
        },
      },
    };

    try {
      if (isMock) {
        setTimeout(() => {
          data.value = sampleDataGetAiOcr;
        }, 2000);
      } else {
        const res = await $api.request(params);

        // console.log("aiOcrInitial: ", res);
        data.value = res;
      }
    } catch (err) {
      error.value = err;
      console.log(err)
      alert(err.message)
    } finally {
      loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
}
